import makeStyles from "@material-ui/styles/makeStyles";

const styles = (maxWidth, noPadding) => {
	return makeStyles(theme => ({
		container: {
			margin: "0 auto",
			maxWidth: maxWidth,
			paddingLeft: noPadding ? 0 : theme.spacing(3),
			paddingRight: noPadding ? 0 : theme.spacing(3),
			width: "100%"
		}
	}))();
};

export default styles;
